export enum ProcessStatus {
  PENDING = "pending",
  QUEUED = "queued",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  FAILED = "failed",
  EXCEEDED_RETRIES = "exceeded_retries",
}

export interface ProcessData {
  id: string;
  hccId: string;
  userId?: string;
  status: ProcessStatus;
  /** Progress percentage (0-100) */
  progress: number;
  /** Arbitrary key-value output data from the process */
  output?: Record<string, unknown>;
  /** UTC datetime string in 'YYYY-MM-DD HH:mm:ss' format */
  createdAt: string;
  /** UTC datetime string in 'YYYY-MM-DD HH:mm:ss' format */
  startedAt?: string;
  /** UTC datetime string in 'YYYY-MM-DD HH:mm:ss' format */
  finishedAt?: string;
  /** Execution time in seconds (from started to finished) */
  execTime?: number;
  /** Lead time in seconds (from created to now/finished) */
  leadTime: number;
}

export interface ProcessStartResponse {
  processId: string;
  message: string;
  estimatedTimeSeconds: number;
}

